import './Styles/App.css';

import React, { useState, useEffect, useRef } from 'react';

import { BrowserRouter, HashRouter, Routes, Route } from 'react-router-dom';

//import crypto from 'crypto-browserify'; // Needed for SHA256 hashing in the browser

import { Home } from './Pages/home';
import { Login } from './Pages/login';
import { Scopes } from './Pages/scopes';
import { Logout } from './Pages/logout';
import { Welcome } from './Pages/welcome'; 
import { Error } from './Pages/error'; 
import { PPL } from './Pages/ppl'; 
import { GoogleCallback } from './Pages/GoogleCallback'; 

import { useLoading } from "./Contexts/LoadingContext";

import { Unauthorized } from './Pages/unauthorized'; 

import { Layout } from './Layout.jsx'; 
import {Spinner} from './Components/Spinner'

import { ModalProvider } from './Contexts/ModalContext';

import axios from "axios"

import { AppContext, AppContextProvider } from './Contexts/AppContextProvider';

import { CLIENT, OAUTH_URI, API_BASE_URI, API_URI, ACCOUNTS_URI, APP_URI } from './config/constants';

function App() {
  const referrer = document.referrer;
  const isRedirected = referrer && referrer !== ''; // If referrer is not empty, it's a redirect.

  const userClientId = localStorage.getItem('userClientId') || crypto.randomUUID();
  localStorage.setItem('userClientId', userClientId);

  function getCookie(cookieName) {
    const cookies = document.cookie;
    const cookieArray = cookies.split(';');
    
    for (let i = 0; i < cookieArray.length; i++) {
        const cookie = cookieArray[i].trim();
        if (cookie.startsWith(cookieName + '=')) {
            return cookie.substring(cookieName.length + 1);  // Return cookie value
        }
    }
    return null;  // Return null if cookie is not found
  }

  // Security Pre-Processing********************************************************************
  
  var ipinfo = {};
  var ipify = {};
  var screenSize = {};
  var deviceInfo = {};
  var deviceLocationStatus = "Unknown";

  const [RSAKeypairRequested, setRSAKeypairRequested] = useState(false);
  const [pkceRequested, setPkceRequested] = useState(false);

  const { setLoading } = useLoading();

  //const applnContext = useContext(AppContext);
  
  // Use Effect *****************************************************************************
  useEffect(() => {
    console.log("*** accounts.radikle UseEffect - getting client data ***"); 

    const fetchData = async () => {
      setLoading(true);

      try {
        await getAndStoreClientData();

        if(!RSAKeypairRequested) {
          setRSAKeypairRequested(true);
          //Run the key generation
          await generateDPoPKeyPair();
        }

        if(!pkceRequested) {  
          setPkceRequested(true);
          await pkce();   
        }

        await createUserClientSession();

        setData(true);
      }  
      catch (err) {
        console.log(err); // Handle error if any async call fails
      }
      finally {
        console.log("*** accounts.radikle UseEffect Completed ***"); 
        setLoading(false);
      }
    }

    if(isRedirected) {
      console.log("INFO: Accounts App is Launched by a client");
      sessionStorage.setItem("CLIENT_REDIRECT", true);
      sessionStorage.setItem("AUTHORIZATION_INITIALIZED", true);
      
    }
    else {
      sessionStorage.setItem("CLIENT_REDIRECT", false);
      sessionStorage.setItem("AUTHORIZATION_INITIALIZED", false);
      fetchData();
    }

  }, []);   // Empty Dependency Array - 
            // Executed only once when the page launches but not on every re-render
  
  async function getAndStoreClientData() {
    if(sessionStorage.getItem("User-Client-Data") != null) {
      console.log("INFO: User Client Data is already obtained.");
    }
    else {      
      console.log("INFO: Getting ScreenAndDeviceInfo");
      await getScreenAndDeviceInfo();

      console.log("INFO: Getting ClientIPInfo");
      await getClientIPInfo();

      let data = {
        'clientID': "radikle",
        'userClient' : {
          'userClientID': userClientId,
          'userClientIP': ipinfo.ip,
          'userAgent': deviceInfo.userAgent,
        },
        'screenInfo': screenSize,
        'deviceInfo': deviceInfo,
        'ipGeoLocation': ipinfo
      };

      sessionStorage.setItem("User-Client-Data", JSON.stringify(data));
      console.log("INFO: ScreenAndDeviceInfo and ClientIPInfo obtained and stored in Session.");
      window.myGlobalVariable.appState.data = data;
    }
  }

  async function createUserClientSession() {
    if(!clientSessionRequested) {
      setClientSessionRequested(true);
      await createClientSession();
      await fetchUserLocation();
      await createClientDialog();
    }
  }

  const [clientSessionRequested, setClientSessionRequested] = useState(false);

  const ipifyRequested = useRef(false);
  const ipinfoRequested = useRef(false);
  
  //********************************************************************************/
  /* A client session needs to be established first before proceeding with any further
     dialog with the server */
  async function createClientSession() {
    var data = JSON.parse(sessionStorage.getItem("User-Client-Data"));
    var clientSessionID = sessionStorage.getItem("User-Client-Session-ID");
    if(clientSessionID != null) {
      console.log("INFO: A client session already exists. Hence a new session need not be created.");
      return;
    }
    await axios.post(OAUTH_URI + "/user-client-data", data, { withCredentials: true })
      .then((response) => {
        if (response.status === 200) {
          let sessionID = response.data;
          sessionStorage.setItem("User-Client-Session-ID", sessionID);
          console.log("INFo: A Client Session with ID is obtained and stored in Session.");
        }
      }).catch((error) => {
        console.log("Error: While obtaining Client Session with ID");
        console.log(error.message);
      });
  }

  const retrieveJSONPublicKeyFromSessionStorage = require('./scripts/Utils.js').retrieveJSONPublicKeyFromSessionStorage;

  //*******************************************************************************
  // A client dialog is created to obtain CSRF Token. 
  // A valid client Session is required beforehand to create the dialog 
  async function createClientDialog() {
    var clientSessionID = sessionStorage.getItem("User-Client-Session-ID");
    if(clientSessionID == null) {
      console.log("Info: A client session does not yet exist. Hence a dialog cannot be created.");
      return;
    }
    var clientCSRFToken = sessionStorage.getItem("User-Client-Session-CSRF-Token");
    if(clientCSRFToken != null) {
      console.log("INFO: A client CSRF Token already exists for the Session. Hence a new dialog need not be created.");
      return;
    }

    console.log("INFO: Obtaining client dialog.");
    const publicKeyJwk = retrieveJSONPublicKeyFromSessionStorage();

    let data = {
      'userClientSessionID': clientSessionID,
      'userClientID': userClientId,
      'deviceLocation' : {
        "latitude": sessionStorage.getItem("Geo-Position-Latitude"),
        "longitude": sessionStorage.getItem("Geo-Position-Longitude"),
      },
      'deviceLocationStatus': deviceLocationStatus,
      'dPoPPublicKeyJWK': publicKeyJwk
    };

    await axios.post(OAUTH_URI + "/user-client-dialog", data, { withCredentials: true })
      .then((response) => {
        if (response.status === 200) {
          let csrfToken = response.data;
          sessionStorage.setItem("User-Client-Session-CSRF-Token", csrfToken);
          console.log("INFO: Client Session CSRF Token obtained and stored in Session");
        }
      }).catch((error) => {
        console.log("Error: while obtaining Client Session CSRF Token");
        console.log(error.message);
      });
  }
  
  
  //**************************************************************************** */

  //The navigator.geolocation.getCurrentPosition method is asynchronous and uses 
  // a callback pattern, meaning you can't directly await it. 
  // However, you can wrap it in a Promise to make it compatible with async/await
  function getCurrentPositionAsync() {
    return new Promise((resolve, reject) => {
      if(navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            (position) => resolve(position), // Success callback
            (error) => reject(error)        // Error callback
        );
      }
    });
  }

  // Function to fetch user geolocation
  async function fetchUserLocation() {
    if(sessionStorage.getItem("User-Device-Location-Status") != null) {
      console.log("INFO: User has already been requested for device location info.");
      return;
    }

    try {
      const position = await getCurrentPositionAsync();
      sessionStorage.setItem("Geo-Position-Latitude", position.coords.latitude);
      sessionStorage.setItem("Geo-Position-Longitude", position.coords.longitude);
      console.log("INFO: Latitude and Longitude information obtained and stored in Session");
      deviceLocationStatus = "User accepted the request for Geolocation."
    } 
    catch (error) {
      console.error("Error: while fetching device location:", error.message);
      switch(error.code) {
        case error.PERMISSION_DENIED:
          deviceLocationStatus = "User denied the request for Geolocation.";
          break;
        case error.POSITION_UNAVAILABLE:
          deviceLocationStatus = "Location information is unavailable.";
          break;
        case error.TIMEOUT:
          deviceLocationStatus = "The request to get user location timed out.";
          break;
        case error.UNKNOWN_ERROR:
          deviceLocationStatus = "An unknown error occurred.";
          break;
      }
    }
    sessionStorage.setItem("User-Device-Location-Status", deviceLocationStatus);
    console.log("INFO: Device Location Status: "+deviceLocationStatus);    
  }

  async function getScreenAndDeviceInfo() {
    // Screen information
    screenSize = {
      width: window.screen.width,
      height: window.screen.height,
      pixelRatio: window.devicePixelRatio
    };

    // Other device-related information
    deviceInfo = {
      userAgent: navigator.userAgent,
      language: navigator.language,
      platform: navigator.hardwareConcurrencyplatform,
      cookiesEnabled: navigator.cookieEnabled,
      concurrency: navigator.hardwareConcurrency,
      online: navigator.onLine
    };

    console.log('INFO: Screen Information and Device Information obtained');
  }

  
  // Function to gather user information
  async function getClientIPInfo(){
    // Make a request to the ipify.org API
    try {
      if(!ipifyRequested.current) {
        ipifyRequested.current = true;
        let userIPIpify = await fetch('https://api64.ipify.org?format=json');
        ipify = await userIPIpify.json();
      }
      console.log('INFO: IP Information obtained from ipify,')
    }
    catch(error) {
      console.error('Error fetching IP from ipify:', error);
    }

    // Make a request to the IPinfo.io API
    try {
      
      if(!ipinfoRequested.current) {
        ipinfoRequested.current = true;
        let userIPIpinfo = await fetch('https://ipinfo.io/json');
        ipinfo = await userIPIpinfo.json();
      }
      console.log('INFO: IP Information obtained from ipinfo,')
    }
    catch(error) {
      console.error('Error: while fetching IP from ipinfo:', error);
    }
  }
  
  // RSA Key Pair - ***********************************************************************
  // Parameters for RSA key generation
  const rsaParams = {
    name: "RSA-OAEP",
    modulusLength: 2048,          // Length of the key (e.g., 2048 bits)
    publicExponent: new Uint8Array([1, 0, 1]), // Common value: 65537
    hash: "SHA-256",               // Hash function to use
  };

  const keyGenParams = {
    name: "ECDSA",
    namedCurve: "P-256", // Curve: P-256 is widely used for DPoP
  };

  var storeKeyPairInSessionStorageForDPoP = require('./scripts/Utils.js').storeKeyPairInSessionStorageForDPoP;


  // Generate DPoP key pair
  async function generateDPoPKeyPair() {
    if(sessionStorage.getItem("DPoP_Public_Key") != null &&
       sessionStorage.getItem("DPoP_Private_Key") != null) {
        console.log("INFO: DPoP Key Pair are already available in Session");
        return;
    }
    try {
      // Generate an ECDSA key pair
      const keyPair = await window.crypto.subtle.generateKey(
        {
          name: "ECDSA",
          namedCurve: "P-256", // Curve: P-256 is widely used for DPoP
        },
        true, // Keys should be extractable to include the public key in the DPoP proof
        ["sign", "verify"] // Key usages
      );
    
      await storeKeyPairInSessionStorageForDPoP(keyPair);
      console.log("INFO: DPoP Key Pair are generated and stored Session");

    } catch (err) {
      console.error("Error: while generating DPoP key pair:", err);
    }
  }

  // Generate RSA key pair
  async function generateRSAKeyPair() {
    if(sessionStorage.getItem("RSA_Public_Key") != null &&
       sessionStorage.getItem("RSA_Private_Key") != null) {
        console.log("INFO: RSA Key Pair are already available in Session");
        return;
    }

    try {
      const keyPair = await window.crypto.subtle.generateKey(
        rsaParams,
        true,          // Extractable key: can be exported if true
        ["encrypt", "decrypt"] // Usages for the key
      );

      // Export public key in a usable format (e.g., PEM)
      const publicKey = await window.crypto.subtle.exportKey("spki", keyPair.publicKey);
      const privateKey = await window.crypto.subtle.exportKey("pkcs8", keyPair.privateKey);

      sessionStorage.setItem("RSA_Public_Key", arrayBufferToBase64(publicKey));
      sessionStorage.setItem("RSA_Private_Key", arrayBufferToBase64(privateKey));
      console.log("INFO: RSA Key Pair are generated and stored in session");
    } catch (err) {
      console.error("Error: while generating RSA key pair:", err);
    }
  }

  // Helper function to convert ArrayBuffer to Base64
  function arrayBufferToBase64(buffer) {
    const binary = String.fromCharCode(...new Uint8Array(buffer));
    return btoa(binary);
  }
  
  // PKCE ********************************************************************************
  async function pkce() {
    if(sessionStorage.getItem("pkce_code_verifier") != null &&
      sessionStorage.getItem("pkce_code_challenge") != null) {
        console.log("INFO: PKCE is already available in Session");
        return;
    }

    try {
      // Initialize PKCE parameters
      const codeVerifier = generateCodeVerifier();
      const codeChallenge = await generateCodeChallenge(codeVerifier);
      sessionStorage.setItem("pkce_code_verifier", codeVerifier);
      sessionStorage.setItem("pkce_code_challenge", codeChallenge);
      sessionStorage.setItem("pkce_code_challenge_method", "S256");
      console.log('INFO: PKCE Code Verifier and Challenge are generated and stored in Session');
    }
    catch(err) {
      console.error("Error: while generating PKCE Verifier and Challenge:", err);
    }
  }

  // Function to generate a random string (code verifier)
  const generateCodeVerifier = () => {
    const array = new Uint32Array(56 / 2);
    window.crypto.getRandomValues(array);
    return Array.from(array, (dec) => dec.toString(16).padStart(2, '0')).join('');
  };

  // Base64 URL encode (RFC 4648)
  function base64UrlEncode(arrayBuffer) {
    return btoa(String.fromCharCode.apply(null, new Uint8Array(arrayBuffer)))
      .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  // Generate a code challenge from the code verifier
  async function generateCodeChallenge(codeVerifier) {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await window.crypto.subtle.digest('SHA-256', data);
    return base64UrlEncode(digest);
  }

  /*
  // Function to create a SHA256-based code challenge
  const generateCodeChallenge = async (verifier) => {
    const hashed = crypto.createHash('sha256').update(verifier).digest('base64');
    return hashed
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, ''); // Convert to base64-url format
  };
  */

  return (
    <>
      <Spinner/>
      <ModalProvider>
      <HashRouter>
        <Routes>
          <Route element={<Layout/>}>
            <Route path="/" element={<Login/>}></Route>
            <Route path="/login" element={<Login/>}></Route>
            <Route path="/scopes" element={<Scopes/>}></Route>
            <Route path="/logout" element={<Logout/>}></Route>
            <Route path="/welcome" element={<Welcome/>}></Route>
            <Route path="/home" element={<Home/>}></Route>
            <Route path="/unauthorized" element={<Unauthorized/>}></Route>
            <Route path="/error" element={<Error/>}></Route>
            <Route path="/callback" element={<GoogleCallback/>}></Route>
            <Route path="/privacy-policy" element={<PPL/>}></Route>
          </Route>
        </Routes>
      </HashRouter>
      <BrowserRouter>
        <Routes>
          <Route path="/privacy-policy" element={<PPL/>}></Route>
        </Routes>
      </BrowserRouter>
      </ModalProvider>      
    </>
  )
}

export default App;
